// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"group-meeting-module--video-container--390JU"};